import { sentFilesTurnArtifacts, type ChatMessageFile, type ConversationAttachmentRef, type SentFilesTurnArtifacts } from "../../schemas/chat-message-files"

interface MessageWithTurnArtifacts {
  turnArtifacts?: object
}

export type IsUserTurn<Message> = (message: NoInfer<Message>) => boolean

interface MessageWithTurnType {
  turnType?: string
}

export function hasUserTurnType(message: MessageWithTurnType): boolean {
  return message.turnType === "user"
}

function lastUserMessageIndex<Message>(messages: Message[], isUserTurn: IsUserTurn<Message>): number {
  for (let messageIndex = messages.length - 1; messageIndex >= 0; messageIndex -= 1) {
    if (isUserTurn(messages[messageIndex])) return messageIndex
  }
  return -1
}

export function lastUserTurnArtifacts<Message extends MessageWithTurnArtifacts>(
  messages: Message[],
  isUserTurn: IsUserTurn<Message>,
): unknown {
  const userMessageIndex = lastUserMessageIndex(messages, isUserTurn)
  return userMessageIndex === -1 ? null : messages[userMessageIndex].turnArtifacts ?? {}
}

export function filesSentWithNextMessage<Message extends MessageWithTurnArtifacts>(
  attachments: ConversationAttachmentRef[],
  messages: Message[],
  isUserTurn: IsUserTurn<Message>,
): SentFilesTurnArtifacts {
  return sentFilesTurnArtifacts(attachments, lastUserTurnArtifacts(messages, isUserTurn))
}

export function withFilesOnLastUserMessage<Message extends MessageWithTurnArtifacts>(
  messages: Message[],
  isUserTurn: IsUserTurn<Message>,
  files: ChatMessageFile[],
): Message[] {
  const userMessageIndex = lastUserMessageIndex(messages, isUserTurn)
  return messages.map((message, messageIndex) =>
    messageIndex === userMessageIndex ? { ...message, turnArtifacts: { ...message.turnArtifacts, files } } : message,
  )
}
